@if (dateTimeForm) {
  <form
    [formGroup]="dateTimeForm"
    [class]="controlCustomClass ? controlCustomClass : 'flex flex-col w-full'"
  >
    <div class="flex flex-col sm:flex-row gap-2 items-start w-full">
      <mat-form-field
        class="w-full sm:flex-grow"
        [subscriptSizing]="'dynamic'"
        (focusout)="onDateFieldFocusOut($event)"
      >
        @if (dateLabel) {
          <mat-label [ngClass]="labelClass">{{ dateLabel }}</mat-label>
        }
        <!-- @if (datePrefix) {
            <mat-icon class="icon-size-5" matPrefix>{{
              datePrefix
            }}</mat-icon>
          } -->
        <input
          #datePicker
          [min]="minDate"
          [max]="maxDate"
          [matDatepicker]="date"
          [placeholder]="datePlaceholder"
          matInput
          formControlName="date"
          (focus)="onDateInputFocus()"
          (mousedown)="onDateInputPointerDown()"
          (blur)="onDateInputBlur()"
        />
        <mat-datepicker
          #date
          [restoreFocus]="restoreFocusOnDatePickerClose"
          (opened)="onDatePickerOpened()"
          (closed)="onDatePickerClosed()"
        ></mat-datepicker>
        <mat-datepicker-toggle
          matIconPrefix
          [for]="date"
        ></mat-datepicker-toggle>
        @if (
          showDateValidationErrors &&
          dateShouldShowValidationErrors &&
          (dateTimeForm?.get('date')?.errors?.required ||
            dateTimeForm?.get('date')?.errors?.matDatepickerParse)
        ) {
          <mat-error
            >A valid date in the format {{ dateFormat }} is required
          </mat-error>
        }
        @if (
          showDateValidationErrors &&
          dateTimeForm?.get('date')?.errors?.dateNotFuture &&
          !!dateTimeForm?.get('date')?.errors?.customDateErrorMessage &&
          !dateTimeForm?.get('date')?.errors?.required
        ) {
          <mat-error>{{
            dateTimeForm.get('date')?.errors?.customDateErrorMessage
          }}</mat-error>
        }
        @if (
          showDateValidationErrors &&
          dateTimeForm?.get('date')?.errors?.dateNotFuture &&
          !dateTimeForm?.get('date')?.errors?.customDateErrorMessage &&
          !dateTimeForm?.get('date')?.errors?.required
        ) {
          <mat-error>Please ensure that this is a future date </mat-error>
        }
        @if (
          showDateValidationErrors &&
          !dateTimeForm?.get('date')?.errors?.dateNotFuture &&
          dateTimeForm?.errors?.dateNotFuture &&
          !dateTimeForm?.get('date')?.errors?.required
        ) {
          <mat-error>Please ensure that this is a future date </mat-error>
        }
        @if (
          showDateValidationErrors &&
          !dateTimeForm?.get('date')?.errors?.required &&
          !dateTimeForm?.errors?.dateNotFuture &&
          dateTimeForm?.get('date')?.errors?.dateNotFuture
        ) {
          <mat-error>Please ensure that this is a future date </mat-error>
        }
        @if (
          showDateValidationErrors &&
          dateTimeForm?.get('date')?.errors?.BEFORE_TIME &&
          !dateTimeForm?.get('date')?.errors?.required
        ) {
          <mat-error>Please ensure that this is a future date </mat-error>
        }
        <!-- <mat-datepicker-toggle matSuffix [for]="date">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle> -->
      </mat-form-field>
      @if (includeTime) {
        <mat-form-field
          class="w-full max-w-48 time-field"
          [subscriptSizing]="'dynamic'"
          (focusout)="onTimeFieldFocusOut($event)"
        >
          <!-- @if (timePrefix) {
      <mat-icon class="icon-size-5" matPrefix>{{ timePrefix }}</mat-icon>
      }  -->
          @if (timeLabel) {
            <mat-label [ngClass]="labelClass">{{ timeLabel }}</mat-label>
          }
          <mat-timepicker
            #timePicker
            [interval]="inforcedMinuteInterval ?? null"
          ></mat-timepicker>
          <mat-timepicker-toggle matIconPrefix [for]="timePicker">
            <mat-icon matTimepickerToggleIcon>schedule</mat-icon>
          </mat-timepicker-toggle>
          <fleet-time-input
            #timeInput
            formControlName="time"
            [displayMode]="timeDisplayMode"
            [intervalSeconds]="inforcedMinuteInterval ?? null"
            [timePicker]="timePicker"
          ></fleet-time-input>
          @if (
            timeInput?.showValidationErrors &&
            dateTimeForm.get('time')?.errors?.invalidInterval &&
            intervalErrorMessage()
          ) {
            <mat-error>{{ intervalErrorMessage() }}</mat-error>
          }
          @if (
            timeInput?.showValidationErrors &&
            dateTimeForm?.get('time')?.errors?.required
          ) {
            <mat-error>{{ timeRequiredErrorMessage }}</mat-error>
          }
          @if (
            timeInput?.showValidationErrors &&
            !dateTimeForm?.get('time')?.errors?.required &&
            !dateTimeForm?.get('time')?.errors?.invalidInterval &&
            dateTimeForm?.get('time')?.errors?.invalidTime
          ) {
            <mat-error>{{ timeInvalidErrorMessage }}</mat-error>
          }
          @if (
            timeInput?.showValidationErrors &&
            dateTimeForm?.get('time')?.errors?.timeNotFuture &&
            !!dateTimeForm?.get('time')?.errors?.customTimeErrorMessage &&
            !dateTimeForm?.get('time')?.errors?.required &&
            !dateTimeForm?.get('time')?.errors?.invalidTime
          ) {
            <mat-error>{{
              dateTimeForm.get('time')?.errors?.customTimeErrorMessage
            }}</mat-error>
          }
          @if (
            timeInput?.showValidationErrors &&
            dateTimeForm?.get('time')?.errors?.timeNotFuture &&
            !dateTimeForm?.get('time')?.errors?.customTimeErrorMessage &&
            !dateTimeForm?.get('time')?.errors?.required &&
            !dateTimeForm?.get('time')?.errors?.invalidTime
          ) {
            <mat-error>Please ensure that this is a future time </mat-error>
          }
          @if (
            timeInput?.showValidationErrors &&
            !dateTimeForm?.get('time')?.errors?.timeNotFuture &&
            dateTimeForm?.errors?.timeNotFuture &&
            !dateTimeForm?.get('time')?.errors?.required &&
            !dateTimeForm?.get('time')?.errors?.invalidTime
          ) {
            <mat-error>Please ensure that this is a future time </mat-error>
          }
          @if (
            timeInput?.showValidationErrors &&
            dateTimeForm?.get('time')?.errors?.BEFORE_TIME &&
            !dateTimeForm?.get('time')?.errors?.required &&
            !dateTimeForm?.get('time')?.errors?.invalidTime
          ) {
            <mat-error>Please ensure that this is a future time </mat-error>
          }
        </mat-form-field>
      }
    </div>
  </form>
}
